"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVerifyEmailSendResponseDto = instanceOfVerifyEmailSendResponseDto;
exports.VerifyEmailSendResponseDtoFromJSON = VerifyEmailSendResponseDtoFromJSON;
exports.VerifyEmailSendResponseDtoFromJSONTyped = VerifyEmailSendResponseDtoFromJSONTyped;
exports.VerifyEmailSendResponseDtoToJSON = VerifyEmailSendResponseDtoToJSON;
exports.VerifyEmailSendResponseDtoToJSONTyped = VerifyEmailSendResponseDtoToJSONTyped;
/**
 * Check if a given object implements the VerifyEmailSendResponseDto interface.
 */
function instanceOfVerifyEmailSendResponseDto(value) {
    if (!('sent' in value) || value['sent'] === undefined)
        return false;
    if (!('expiresInSeconds' in value) || value['expiresInSeconds'] === undefined)
        return false;
    return true;
}
function VerifyEmailSendResponseDtoFromJSON(json) {
    return VerifyEmailSendResponseDtoFromJSONTyped(json, false);
}
function VerifyEmailSendResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sent': json['sent'],
        'expiresInSeconds': json['expiresInSeconds'],
        'verificationToken': json['verificationToken'] == null ? undefined : json['verificationToken'],
    };
}
function VerifyEmailSendResponseDtoToJSON(json) {
    return VerifyEmailSendResponseDtoToJSONTyped(json, false);
}
function VerifyEmailSendResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'sent': value['sent'],
        'expiresInSeconds': value['expiresInSeconds'],
        'verificationToken': value['verificationToken'],
    };
}
